// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 962 ? "home" : chunkId) + "." + {"570":"8c6056c1","962":"aa50770e"}[chunkId] + ".css";
};